import * as React from "react";

interface VideoPlayerState {
    open: boolean;
}

interface VideoPlayerProps {
    videoID: string;
}

interface VideoModalProps {
    videoID: string;
    open: boolean;
    toggle: () => void;
}

function vimeoURL(videoID: string): string {
    return `//player.vimeo.com/video/${videoID}?api=1&&title=0&byline=0&portrait=0&autoplay=1`;
}

function VideoModal({ videoID, open, toggle }: VideoModalProps): JSX.Element | null {
    if (!open) {
        return null;
    }
    return (
        <div className="modal-backdrop" onClick={toggle}>
            <iframe
                onClick={e => e.stopPropagation()}
                src={vimeoURL(videoID)}
                frameBorder="0"
                width="980px"
                height="480px"
                allowFullScreen={true}
            />
        </div>
    );
}

export class VideoPlayer extends React.Component<VideoPlayerProps, VideoPlayerState> {

    constructor(props: VideoPlayerProps) {
        super(props);
        this.state = { open: false };
    }

    toggleBodyLock() {
        const overflow = document.body.style.overflow;
        document.body.style.overflow = overflow === "hidden" ? "auto" : "hidden";
    }

    toggle = () => {
        this.toggleBodyLock();
        this.setState({ open: !this.state.open });
    }

    render() {
        return (
            <span>
                <a className="open-modal-button" onClick={this.toggle}>
                    <i className="fa fa-play" aria-hidden="true"></i> Click to View
                </a>
                <VideoModal open={this.state.open} toggle={this.toggle} videoID={this.props.videoID} />
            </span>
        );
    }
}


// WEBPACK FOOTER //
// ./src/ts/components/video_player.tsx